export default __webpack_public_path__ + "static/media/a011-fsi-02.67123dbb.svg";